let _initProto;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import { Plugin } from "plugin";
import * as fs from "fs";
import { TextDecoder } from "encoding";
import { TextEncoder } from "encoding";
import { readline } from "./service-fermentation-utils.js";
import globalSettings from "../inc/settings.js";
import { http } from "appserver";
import { auth } from "appserver";
import { URL } from "url";
import { ReadableStream } from "web-streams";
const PATH = "/var/lib/biocore/server/fermentations";
const SAMPLING_RATE = 3000; /* sampling interval in ms*/

var pre_error = 0;
var DO_pre_error = 0;
var PH_pre_error = 0;
var vars = {};
export default class Service extends Plugin {
  static {
    [_initProto] = _applyDecs(this, [], [[[http.get("/api/pc/fermentations"), auth.validate()], 2, "fermentations_list"], [[http.get(/^\/api\/pc\/fermentations\/[^/]+$/), auth.validate()], 2, "fermentations_get"], [[http.put(/^\/api\/pc\/fermentations\/[\w-]+$/), auth.validate()], 2, "fermentations_save"], [[http.delete(/^\/api\/pc\/fermentations\/[\w-]+$/), auth.validate()], 2, "fermentation_remove"], [[http.get("/api/pc/fermentations-sse"), auth.validate()], 2, "fermentations_sse"], [[http.get("/api/pc/devices"), auth.validate()], 2, "devices_list"], [[http.get(/^\/api\/pc\/devices\/[\w-]+$/), auth.validate()], 2, "device_get"], [[http.post(/^\/api\/pc\/devices\/([\w-]+)\/([\w-]+)$/), auth.validate()], 2, "device_command"]], 0, void 0, Plugin).e;
  }
  constructor(...args) {
    _initProto(super(...args));
    this.timer = setInterval(this.ontimeout.bind(this), SAMPLING_RATE);
    this.addEventListener("stop", this.stop_handler.bind(this));
    this.hasValidMeasurements = false;

    /* find live fermentation on this unit */
    this.running = false;
    /* check if we have a running fermentation. if so we try to continue that */
    var fermentations = this.listFermentations();
    for (var fermentation in fermentations) {
      if (fermentations[fermentation].running) {
        /* TODO: repetive block, same as starting a new fermentation */
        this.running = fermentations[fermentation].id;
        this.currentFermentation = fermentations[fermentation];
        this.endDate = new Date(fermentations[fermentation].endDate);

        /* Restore PID values if case of jfermi unexpected restart */
        this.errorSum = parseFloat(localStorage.getItem("__errorSum")) || 0;
        this.stirringErrorSum = parseFloat(localStorage.getItem("__stirringErrorSum")) || 0;
        this.phErrorSum = parseFloat(localStorage.getItem("__phErrorSum")) || 0;
        this.DO_PID_ENABLED = false;
        var runningfermentation = fermentations[fermentation];
        runningfermentation.isContinuation = true;
        this.dispatchEvent(new CustomEvent("fermentationstart", {
          detail: runningfermentation
        }));
        console.warn(`system: Continuing fermentation: ${this.running}`);
      }
    }
  }
  ontimeout() {
    let settings = JSON.parse(localStorage.getItem("settings"));

    /* deep copy device objects */
    var devices = JSON.parse(JSON.stringify(this.devices));

    /* if a device is not updated for some reason, for example transient communication error  */
    /* then we put null into the value of the sensor in question                              */
    /* if a sensor value is not a number then we have to skip the PID control in that cycle   */

    /* if the target value (temperature, dissolved oxygen) contains a number then             */
    /* we regulate that evnironmental variable if it is null we skip the regulation           */

    /* here we do the PID control and logging if the fermentation is running and we have valid measurements */
    if (this.hasValidMeasurements && this.running) {
      if (this.devices.leds) {
        this.devices.leds.yellow = !this.devices.leds.yellow;
      }

      /* control */

      /* feed rate control */
      let feedPump;
      if (this.devices.feedPump) feedPump = this.devices.feedPump;
      if (this.devices.ezoPumpFeed) feedPump = this.devices.ezoPumpFeed;
      if (this.devices.parallaxPumpFeed) feedPump = this.devices.parallaxPumpFeed;
      if (Number.isFinite(this.currentFermentation.feedRate) && feedPump) {
        //console.log(`Feed control`);
        feedPump.setMLH(this.currentFermentation.feedRate);
      }

      /* tempareture PID control */
      var T;
      if (devices.temperatureSensor) T = devices.temperatureSensor.value;
      if (devices.ezortdSensor) T = devices.ezortdSensor.value;
      if (Number.isFinite(this.currentFermentation.targetTemperature) && Number.isFinite(T)) {
        //console.log(`Temperature control`);
        let error = T - this.currentFermentation.targetTemperature;
        this.errorSum += error;
        let Pout = settings.T_Kp * error; //Proportional term
        let Iout = settings.T_Ki * (this.errorSum * 3); //Integrative term
        let Dout = settings.T_Kd * ((error - pre_error) / 3); //Derivative term

        let output = Pout + Iout + Dout;
        output = Math.min(100, output);
        output = Math.max(-40, output);
        this.devices.thermostat.percentage = Math.abs(output);
        this.devices.thermostat.mode = output < 0 ? 1 : 0;
        pre_error = error;

        //localStorage.setItem("__errorSum", this.errorSum);
      }

      /* dissolved Oxygen PID control */
      /* 
        Integral windup occurs when the controller's output can no longer affect the controlled variable
        We address the problem by not increasing the integral if the input does not affect the output
        we reached the maximum output (for example 1200 RPM stirring)
      */

      var DO;
      if (devices.dissolvedOxygenSensor) DO = devices.dissolvedOxygenSensor.value;
      if (devices.ezodoSensor) DO = devices.ezodoSensor.value;
      if (devices.visifermdo) DO = devices.visifermdo.value;
      if (Number.isFinite(this.currentFermentation.oxygenLevel) && Number.isFinite(DO)) {
        //console.log(`DO control`);
        let output = 0;
        let error = DO - this.currentFermentation.oxygenLevel;
        error *= -1;
        let stirringErrorSumOld = this.stirringErrorSum;
        this.stirringErrorSum += error;
        let Omin = settings.Stirring_MIN_RPM;
        let Pout = settings.DO_Kp * error; //Proportional term
        let Iout = settings.DO_Ki * (this.stirringErrorSum * 3); //Integrative term

        output = Omin + Pout + Iout;
        output = Math.min(settings.Stirring_MAX_RPM, output);
        output = Math.max(settings.Stirring_MIN_RPM, output);
        if (settings.Stirring_MIN_RPM >= output || output >= settings.Stirring_MAX_RPM) {
          this.stirringErrorSum = stirringErrorSumOld;
        }
        this.devices.stirring.rpm = output;

        //localStorage.setItem("__stirringErrorSum", this.stirringErrorSum);
      }

      /* PH PID control */
      var PH;
      if (devices.pHSensor) PH = devices.pHSensor.value;
      if (devices.ezophSensor) PH = devices.ezophSensor.value;
      if (devices.visifermph) PH = devices.visifermph.value;
      let acidPump;
      if (this.devices.acidPump) acidPump = this.devices.acidPump;
      if (this.devices.ezoPumpAcid) acidPump = this.devices.ezoPumpAcid;
      if (this.devices.parallaxPumpAcid) acidPump = this.devices.parallaxPumpAcid;
      let basePump;
      if (this.devices.basePump) basePump = this.devices.basePump;
      if (this.devices.ezoPumpBase) basePump = this.devices.ezoPumpBase;
      if (this.devices.parallaxPumpBase) basePump = this.devices.parallaxPumpBase;
      if (Number.isFinite(this.currentFermentation.targetPH) && Number.isFinite(PH)) {
        //console.log(`PH control`);
        let error = PH - this.currentFermentation.targetPH;
        this.phErrorSum += error;
        let Pout = settings.PH_Kp * error; //Proportional term
        let Iout = settings.PH_Ki * (this.phErrorSum * 3); //Integrative term

        let output = Pout + Iout;

        // hardware max, min
        //output = Math.min(20, output);
        //output = Math.max(-20, output);

        let output_acid = output > 0 ? output : 0;
        let output_base = output < 0 ? Math.abs(output) : 0;
        output_acid = Math.min(settings.AcidPump_MAX_MLH, output_acid);
        output_acid = Math.max(settings.AcidPump_MIN_MLH, output_acid);
        output_base = Math.min(settings.BasePump_MAX_MLH, output_base);
        output_base = Math.max(settings.BasePump_MIN_MLH, output_base);

        /*                     
          Acidic(0) .. Neutral (7) .. Basic(14)                    
        */
        /*
          TODO: if the output does not change, we should not increase the Integrative term          
        */
        if (Number.isFinite(this.currentFermentation.pHDeadband) && Math.abs(PH - this.currentFermentation.targetPH) <= this.currentFermentation.pHDeadband) {
          output_acid = 0;
          output_base = 0;
        }
        if (acidPump) acidPump.setMLH(output_acid);
        if (basePump) basePump.setMLH(output_base);

        //localStorage.setItem("__phErrorSum", this.phErrorSum);
      }

      /* call control method on each connected device, TODO: move each control to separate module */
      for (var device in this.devices) {
        if (typeof this.devices[device].control == "function") this.devices[device].control(this.currentFermentation, devices, settings).catch(function (device, e) {
          console.error(`${device} control failed: ${e.message}`);
        }.bind(this, device));
      }
      //this.dispatchEvent( new CustomEvent("control", {detail: devices}) );      

      /* run user defined scripts */

      var arrayBuffer = fs.readFileSync("/var/lib/biocore/server/control/user/index.js");
      var uint8Array = new Uint8Array(arrayBuffer);
      var userscript = new TextDecoder().decode(uint8Array);
      let startTime = new Date(this.currentFermentation.inoculationDate).getTime();
      let currTime = new Date().getTime();
      let h = (currTime - startTime) / (1000 * 60 * 60);
      let logs = [];
      function logData(name, value) {
        logs.push([name, value]);
      }
      jfermi.addEventListener("logdata", function (e) {
        logs.forEach(log => e.detail.logData.append(...log));
        logs = [];
      }.bind(this));
      var predefs = {
        h: h,
        T: T,
        pO2: DO,
        pH: PH,
        target_pO2: this.currentFermentation.oxygenLevel,
        target_T: this.currentFermentation.targetTemperature,
        target_pH: this.currentFermentation.targetPH,
        STR: this.devices.stirring.rpm,
        GSFL: this.devices.iqflow ? this.devices.iqflow.targetValue : undefined,
        devices: this.devices,
        settings: globalSettings,
        vars: vars,
        stop: this.finishCurrentFermentation.bind(this),
        log: function (...args) {
          console.log(...args);
        },
        logData: logData.bind(this)
      };
      var func = new Function(Object.keys(global).concat(Object.keys(predefs)).join(","), "'use strict';" + userscript);
      try {
        //mask global functions and add predefined ones
        func.apply(null, Object.values(global).map(o => undefined).concat(Object.values(predefs)));
      } catch (e) {
        console.error(`user script error: ${e.message}`);
      }

      /* fermentation end control */
      if (this.endDate && this.endDate < new Date()) {
        this.finishCurrentFermentation();
      }
    }

    /* if we have measurement then we publish the values */
    if (this.hasValidMeasurements) {
      this.dispatchEvent(new CustomEvent("update", {
        detail: devices
      }));
    }

    /* TODO: do not start a new measurement cycle until all finished */
    /* use timeout in every device to ensure it finished in time     */

    var promises = [];
    /* Update device status */
    for (var device in this.devices) {
      var promise = this.devices[device].update(devices);
      promises.push(promise);
      promise.catch(function (device, result) {
        console.error(`system: Failed to update ${device}: ${result}`);
        if (result.message == "Timeout") this.devices.leds.red = 1;
      }.bind(this, device));
    }
    this.hasValidMeasurements = true;
  }
  stop_handler(event) {
    console.warn(`Emergency stop: ${event.detail}`);
    this.finishCurrentFermentation();
    this.idleControls();
  }

  /* put each connected control into idle state */
  /* e.g.: stop heating, stop pumps, etc.       */
  idleControls() {
    //optional chaning assignment only at stage 1, do not use it now
    //this.devices.thermostat?.percentage = 0;

    if (this.devices.thermostat) this.devices.thermostat.percentage = 0;
    if (this.devices.stirring) this.devices.stirring.rpm = 0;
    this.devices.acidPump?.setMLH(0);
    this.devices.basePump?.setMLH(0);
    this.devices.feedPump?.setMLH(0);
    this.devices.antifoamPump?.setMLH(0);
    if (!settings["Airflow_disable"]) {
      this.devices.airflow.setMLM(0);
    }
  }

  /* stop the currently running fermentation if any */
  /* e.g.: stop heating, stop pumps, etc.           */
  finishCurrentFermentation() {
    if (!this.running) return;
    var fermentation = this.getFermentation(this.currentFermentation.id);
    fermentation.running = false;
    this.saveFermentation(fermentation.id, fermentation);
    console.log(`system: fermentation finised: ${this.running}`);
    this.running = false;
    this.dispatchEvent(new CustomEvent("fermentationend", {
      detail: fermentation
    }));
  }
  getFermentations() {
    let result = fs.readdirSync(PATH).filter(function (name) {
      return name != "." && name != "..";
    }).map(function (name) {
      return PATH + "/" + name + "/parameters.json";
    }).map(function (path) {
      const arrayBuffer = fs.readFileSync(path);
      const decoder = new TextDecoder();
      const str = decoder.decode(arrayBuffer);
      const json = JSON.parse(str);
      return json;
    });
    return result;
  }

  /* TODO: remove */
  listFermentations() {
    console.info("listFermentations: deprecate soon.");
    return fs.readdirSync(PATH).filter(function (name) {
      return name != "." && name != "..";
    }).map(function (name) {
      return PATH + "/" + name + "/parameters.json";
    }).map(function (path) {
      var arrayBuffer = fs.readFileSync(path);
      var str = String.fromCharCode.apply(null, new Uint8Array(arrayBuffer));
      var json = JSON.parse(str);
      return json;
    });
  }
  getFermentation(id) {
    var arrayBuffer = fs.readFileSync(`${PATH}/${id}/parameters.json`);
    var str = new TextDecoder().decode(new Uint8Array(arrayBuffer));
    var json = JSON.parse(str);
    return json;
  }
  saveFermentation(id, fermentation) {
    const encoder = new TextEncoder();
    fs.writeFileSync(`${PATH}/${id}/parameters.json`, encoder.encode(JSON.stringify(fermentation)).buffer);
  }

  //get the list of fermentations
  async fermentations_list(request) {
    let fermentations = this.getFermentations();
    return new Response(JSON.stringify(fermentations), {
      status: 200,
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    });
  }

  //get metadata of a specific fermentation
  async fermentations_get(request) {
    const url = new URL(request.url);
    const parts = url.pathname.split("/");

    // last path segment is your id
    const id = decodeURIComponent(parts[parts.length - 1]);
    var arrayBuffer = fs.readFileSync(`${PATH}/${id}/parameters.json`);
    var str = new TextDecoder().decode(new Uint8Array(arrayBuffer));
    return new Response(str, {
      status: 200,
      headers: {
        "Content-Type": "application/json"
      }
    });
  }

  /* TODO: createing a fermentation with an already existing name will overwrite the old one!!!, use PUT and PATCH */
  async fermentations_save(request) {
    let fermentation = await request.json();
    const username = request.__jwt_payload.username;
    const encoder = new TextEncoder();

    // a fermentation is already running
    if (this.running && fermentation.running && this.running != fermentation.id) {
      return new Response("Another fermentation is already running", {
        status: 409,
        headers: {
          "Content-Type": "text/plain"
        }
      });
    }
    if (fs.existsSync(`${PATH}/${fermentation.id}/parameters.json`)) {
      fs.writeFileSync(`${PATH}/${fermentation.id}/parameters.json`, encoder.encode(JSON.stringify(fermentation)).buffer);
      console.log(`${username}: Fermentation updated: ${fermentation.id}`);
    } else {
      /* Create fermentation */
      console.log(`${PATH}/${fermentation.id}`);
      fs.mkdirSync(`${PATH}/${fermentation.id}`);
      fs.writeFileSync(`${PATH}/${fermentation.id}/parameters.json`, encoder.encode(JSON.stringify(fermentation)).buffer);
      fs.writeFileSync(`${PATH}/${fermentation.id}/values.json`, encoder.encode("").buffer);
      fs.writeFileSync(`${PATH}/${fermentation.id}/values.csv`, encoder.encode("dt,temp,ph,co2,o2,do,percentage,mode,voltage,current,power,stirring,acid_mlh,acid_summl,base_mlh,base_summl,feed_mlh,feed_summl,antifoam_mlh,antifoam_summl,airflow\n").buffer);
      console.log(`${username}: Fermentation created: ${fermentation.id}`);
      this.dispatchEvent(new CustomEvent("fermentationupdate", {
        detail: fermentation
      }));
    }

    /* start new fermentation */
    if (!this.running && fermentation.running) {
      this.running = fermentation.id;
      this.currentFermentation = fermentation;
      this.endDate = new Date(fermentation.endDate);
      this.errorSum = 0;
      this.stirringErrorSum = 0;
      this.phErrorSum = 0;
      this.DO_PID_ENABLED = false;
      this.dispatchEvent(new CustomEvent("fermentationstart", {
        detail: fermentation
      }));
      console.log(`${username}: Fermentation started: ${fermentation.id}`);
      return new Response("Ok", {
        status: 200,
        headers: {
          "Content-Type": "text/plain"
        }
      });
    }

    /* update current fermentation */
    if (this.running == fermentation.id && fermentation.running) {
      this.currentFermentation = fermentation;
      this.endDate = new Date(fermentation.endDate);
      console.log(`${username}: Live fermentation updated: ${fermentation.id}`);
      this.dispatchEvent(new CustomEvent("fermentationupdate", {
        detail: fermentation
      }));
      return new Response("Ok", {
        status: 200,
        headers: {
          "Content-Type": "text/plain"
        }
      });
    }

    /* stop current fermentation */
    if (this.running == fermentation.id && !fermentation.running) {
      delete this.running;
      console.log(`${username}: Fermentation stopped: ${fermentation.id}`);
      if (this.devices.leds) this.devices.leds.yellow = 0;
      if (this.devices.thermostat) this.devices.thermostat.percentage = 0;
      if (this.devices.stirring) this.devices.stirring.rpm = 0;
      let acidPump;
      if (this.devices.acidPump) acidPump = this.devices.acidPump;
      if (this.devices.ezoPumpAcid) acidPump = this.devices.ezoPumpAcid;
      if (this.devices.parallaxPumpAcid) acidPump = this.devices.parallaxPumpAcid;
      let basePump;
      if (this.devices.basePump) basePump = this.devices.basePump;
      if (this.devices.ezoPumpBase) basePump = this.devices.ezoPumpBase;
      if (this.devices.parallaxPumpBase) basePump = this.devices.parallaxPumpBase;
      let feedPump;
      if (this.devices.feedPump) feedPump = this.devices.feedPump;
      if (this.devices.ezoPumpFeed) feedPump = this.devices.ezoPumpFeed;
      if (this.devices.parallaxPumpFeed) feedPump = this.devices.parallaxPumpFeed;
      let antifoamPump;
      if (this.devices.antifoamPump) antifoamPump = this.devices.antifoamPump;
      if (this.devices.ezoPumpAntifoam) antifoamPump = this.devices.ezoPumpAntifoam;
      if (this.devices.parallaxPumpAntifoam) antifoamPump = this.devices.parallaxPumpAntifoam;

      /* TODO: move to peripherals/parallaxpump */
      if (acidPump) acidPump.setMLH(0);
      if (basePump) basePump.setMLH(0);
      if (feedPump) feedPump.setMLH(0);
      if (antifoamPump) antifoamPump.setMLH(0);
      localStorage.removeItem("__errorSum");
      localStorage.removeItem("__stirringErrorSum");
      localStorage.removeItem("__phErrorSum");
      this.dispatchEvent(new CustomEvent("fermentationstop", {
        detail: fermentation
      }));
      return new Response("Ok", {
        status: 200,
        headers: {
          "Content-Type": "text/plain"
        }
      });
    }
    return new Response("Ok", {
      status: 200,
      headers: {
        "Content-Type": "text/plain"
      }
    });
  }
  async fermentation_remove(request) {
    const url = new URL(request.url);
    const parts = url.pathname.split("/");
    const id = decodeURIComponent(parts[parts.length - 1]);
    if (this.running == id) {
      return new Response("Can't delete a running fermentation", {
        status: 409,
        headers: {
          "Content-Type": "text/plain"
        }
      });
    }
    fs.unlinkSync(`${PATH}/${id}/parameters.json`);
    fs.unlinkSync(`${PATH}/${id}/values.json`);
    fs.unlinkSync(`${PATH}/${id}/values.csv`);
    fs.rmdirSync(`${PATH}/${id}`);
    this.dispatchEvent(new CustomEvent("fermentationremove", {
      detail: id
    }));

    /* push values to clients */
    //clients.notifyAll("RM_updateFermentations", await this.RM_fermentation_getFermentations());
    return new Response("Ok", {
      status: 200,
      headers: {
        "Content-Type": "text/plain"
      }
    });
  }
  async fermentations_sse(request) {
    console.log("fermentations-sse client connected");
    let startListener; // keep reference to remove later
    let stopListener; // keep reference to remove later
    let updateListener; // keep reference to remove later
    let removeListener; // keep reference to remove later
    let timer;
    const stream = new ReadableStream({
      start: controller => {
        timer = setInterval(() => {
          const message = `:\n\n`;
          controller.enqueue(new TextEncoder().encode(message).buffer);
        }, 1000);
        // Define the listener and bind `this`
        startListener = event => {
          const fermentations = this.getFermentations();
          const message = `data: ${JSON.stringify(fermentations)}`;
          controller.enqueue(new TextEncoder().encode(message).buffer);
        };
        stopListener = event => {
          const fermentations = this.getFermentations();
          const message = `data: ${JSON.stringify(fermentations)}`;
          controller.enqueue(new TextEncoder().encode(message).buffer);
        };
        updateListener = event => {
          const fermentations = this.getFermentations();
          const message = `data: ${JSON.stringify(fermentations)}`;
          controller.enqueue(new TextEncoder().encode(message).buffer);
        };
        removeListener = event => {
          const fermentations = this.getFermentations();
          const message = `data: ${JSON.stringify(fermentations)}`;
          controller.enqueue(new TextEncoder().encode(message).buffer);
        };
        this.addEventListener("fermentationstart", startListener);
        this.addEventListener("fermentationstop", stopListener);
        this.addEventListener("fermentationupdate", updateListener);
        this.addEventListener("fermentationremove", removeListener);

        //force an update to the new clients
        updateListener();
      },
      cancel: reason => {
        console.log("fermentations-sse client closed");
        // Remove the listener and clear interval
        if (startListener) {
          this.removeEventListener("fermentationstart", startListener);
        }
        if (stopListener) {
          this.removeEventListener("fermentationstop", stopListener);
        }
        if (updateListener) {
          this.removeEventListener("fermentationupdate", updateListener);
        }
        if (removeListener) {
          this.removeEventListener("fermentationremove", removeListener);
        }
        if (timer) {
          clearInterval(timer);
        }
      }
    });

    // Return the stream as a Response
    return new Response(stream, {
      status: 200,
      headers: {
        "Content-Type": "text/event-stream",
        "Cache-Control": "no-store",
        "Connection": "Keep-Alive"
      }
    });
  }
  async devices_list(request) {
    //deep copy
    //TODO: should be an array of objects
    let devices = JSON.parse(JSON.stringify(this.devices));
    return new Response(JSON.stringify(devices), {
      status: 200,
      headers: {
        "Content-Type": "application/json"
      }
    });
  }
  async device_get(request) {
    const url = new URL(request.url);
    const parts = url.pathname.split("/");
    const device = parts[parts.length - 1];
    let result = JSON.stringify(this.devices[device]);
    return new Response(result, {
      status: 200,
      headers: {
        "Content-Type": "application/json"
      }
    });
  }
  async device_command(request) {
    const username = request.__jwt_payload.username;
    const url = new URL(request.url);
    const parts = url.pathname.split("/");
    const device = parts[parts.length - 2];
    const action = parts[parts.length - 1];
    const json = await request.json();
    const args = json.args;
    let result;
    try {
      result = await this.devices[device][`RM_${action}`](...args);
      console.log(`${username}: ${device} ${action} ${JSON.stringify(args)}`);
      return new Response("Ok", {
        status: 200,
        headers: {
          "Content-Type": "text/plain"
        }
      });
    } catch (e) {
      console.error(`${username}: ${device} ${action} ${JSON.stringify(args)} failed: ${e.message}`);
      return new Response(e.message, {
        status: 500,
        headers: {
          "Content-Type": "text/plain"
        }
      });
    }
  }
}